"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _Image = require("../../components/Image/Image.styles");
var _constants = require("../../constants");
var _getInitials = require("../../util/getInitials");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _mediaQueryMixin = require("../mediaQueryMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
var sizeCSS = (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('size', function (mediaProps) {
  var children = mediaProps.children,
    fullName = mediaProps.fullName,
    tshirt = mediaProps.size;
  return (0, _styledToken.default)({
    size: "Avatar.sizes." + tshirt,
    fontType: "Avatar.fontTypes." + tshirt
  }, function (_ref) {
    var size = _ref.size,
      fontType = _ref.fontType;
    var content;
    if (typeof children === 'undefined') {
      var initials = (0, _getInitials.getInitials)(fullName);
      // One letter for xs, sm, md sizes
      if (tshirt === _constants.T_SHIRT_SIZES.xs || tshirt === _constants.T_SHIRT_SIZES.sm || tshirt === _constants.T_SHIRT_SIZES.md) {
        initials = initials.charAt(0);
      }
      content = (0, _styledComponents.css)(["&:after{content:'", "';}"], initials);
    }
    return (0, _styledComponents.css)(["width:", "px;max-width:100%;aspect-ratio:1/1;", " ", " > ", "{height:", "px;width:", "px;}> ", "{height:100%;width:100%;object-fit:cover;}"], size, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontColor: null /* color handled separately */,
      fontType: fontType,
      fontTypeIconAlignment: false
    }, mediaProps)), content, _Icon.StyledIcon, size / 2, size / 2, _Image.StyledImage);
  })(mediaProps);
});
var colorCSS = function colorCSS(props) {
  var background = props.background;
  return (0, _styledToken.default)({
    colors: 'colors',
    iconColorOnLight: 'Avatar.iconColorOnLight',
    iconColorOnDark: 'Avatar.iconColorOnDark',
    defaultBackgroundColor: 'Avatar.defaultBackgroundColor',
    defaultColor: 'Avatar.defaultColor',
    colorOnLight: 'Avatar.colorOnLight',
    colorOnDark: 'Avatar.colorOnDark'
  }, function (_ref2) {
    var colors = _ref2.colors,
      defaultBackgroundColor = _ref2.defaultBackgroundColor,
      iconColorOnLight = _ref2.iconColorOnLight,
      iconColorOnDark = _ref2.iconColorOnDark,
      colorOnLight = _ref2.colorOnLight,
      colorOnDark = _ref2.colorOnDark;
    if (!colors) {
      return '';
    }
    return (0, _styledComponents.css)(["background-color:", ";color:", ";> ", "{color:", ";}"], background ? colors[background] : defaultBackgroundColor, background === 'gray200' ? colorOnLight : colorOnDark, _Icon.StyledIcon, background === 'gray200' ? iconColorOnLight : iconColorOnDark);
  })(props);
};

/** @class AvatarMixin */
/** @method */
var AvatarMixin = function AvatarMixin(props) {
  return (0, _styledToken.default)('Avatar.borderRadius', function (borderRadius) {
    return (0, _styledComponents.css)(["overflow:hidden;display:inline-flex;justify-content:center;align-items:center;border-radius:", ";", " ", " ", " ", ""], borderRadius || '50%', sizeCSS(props), (0, _mediaQueryMixin.mediaQueryMixin)(function (mediaProps) {
      return sizeCSS(Object.assign({}, props, mediaProps));
    }), colorCSS(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.AvatarMixin = AvatarMixin;